// extracted by mini-css-extract-plugin
module.exports = {"chooseTeam":"ChooseTeam-styles_chooseTeam__URQvU","teamList":"ChooseTeam-styles_teamList__14FOb","small":"ChooseTeam-styles_small__3_zpL"};